import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import styled from "styled-components";
import GlobalStyles from "./styles/GlobalStyles";
import Header from "./components/Header";
import Footer from "./components/Footer";

// Page components
import Hero from "./components/Hero";
import AboutUs from "./components/Aboutus";
import Features from "./components/Features";
import HowItWorks from "./components/HowItWorks";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import QuickActions from "./components/QuickActions";
import ExploreMore from "./components/ExploreMore";
import Discover from "./components/Discover";
import UIUXDesign from "./components/UIUXDesign";
import WebDevelopment from "./components/WebDevelopment";
import DatabaseManagement from "./components/DatabaseManagement";
import Marketing from "./components/marketing";
import Career from "./components/Career";
import Contact from './components/Contact';
import CareerPage from './components/CareerPage';
import CareerPaths from './components/CareerPaths';
import Internships from './components/Internships';
import JobReadyProgram from "./components/JobReadyProgram";
import TwoYearProgram from "./components/TwoYearProgram";
import ThreeYearProgram from "./components/ThreeYearProgram";
import AIReadyJobProgram from "./components/AIReadyJobProgram";

// Wrapper styling
const ContentWrapper = styled.div`
  padding-top: 58px; /* Account for fixed header + promo bar */
  background-color: var(--gray-0);
  min-height: 100vh;
  overflow-x: hidden;
  width: 100%;

  @media (max-width: 1024px) {
    padding-top: 56px;
  }

  @media (max-width: 768px) {
    padding-top: 54px;
  }
  
  @media (max-width: 480px) {
    padding-top: 52px;
  }
`;

// Home page component
const Home = () => (
  <>
    <Hero />
    <AboutUs />
    <Features />
    <HowItWorks />
    <QuickActions />
    <Testimonials />
    <FAQ />
  </>
);

// Component to conditionally render Footer
const FooterWrapper = () => {
  const location = useLocation();

  // Add any route where footer shouldn't appear
  const noFooterRoutes = ['/career-paths'];
  const showFooter = !noFooterRoutes.includes(location.pathname);

  return showFooter ? <Footer /> : null;
};

// Main App component
const App = () => {
  return (
    <Router>
      <GlobalStyles />
      <Header />
      <ContentWrapper>
        <Routes>
          {/* Public Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/service" element={<Features />} />
          <Route path="/explore-more" element={<ExploreMore />} />
          <Route path="/discover" element={<Discover />} />
          <Route path="/ui-ux-design" element={<UIUXDesign />} />
          <Route path="/web-development" element={<WebDevelopment />} />
          <Route path="/database-management" element={<DatabaseManagement />} />
          <Route path="/marketing" element={<Marketing />} />

          {/* Career Pages */}
          <Route path="/career" element={<Career />} />
          <Route path="/careerpage" element={<CareerPage />} />
          <Route path="/career-paths" element={<CareerPaths />} />
          <Route path="/internships" element={<Internships />} />
          <Route path="/job-ready-program" element={<JobReadyProgram />} />
          <Route path="/ai-ready-program" element={<AIReadyJobProgram />} />
          <Route path="/two-year-program" element={<TwoYearProgram />} />
          <Route path="/three-year-program" element={<ThreeYearProgram />} />
        </Routes>
      </ContentWrapper>
      <FooterWrapper />
    </Router>
  );
};

export default App;
